
'use strict';//Indicating browser should run only in java script mode
//http://stackoverflow.com/questions/20369377/how-to-use-http-get-in-angularjs-correctly-in-specific-for-an-external-api-cal

//*******PURPOSE: The purpose of the service is to handle each and every http wcf calls related to login functionality
//*******EFFECTIVE FILES: Views/Admin/Login.html
//*******CREATED BY: George D
//*******CREATED DATE: 06/14/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

var EnableProductionLoginInSonicWall = false;

EMRLogin.service('LoginService', ['CommonPostService', 'CommonService', 'errorLogService', '$q', "GoogleCloudFunctionHandlerService","CommonErrorMailService",
    function (CommonPostService, CommonService, errorLogService, $q, GoogleCloudFunctionHandlerService,CommonErrorMailService) {

    var self = this;

    //###################GET PRACTICE DETAILS BASED ON LOGIN USERNAME START#########################

    //*******PURPOSE: This method is used to get the practice details of user based on user name
    //*******CREATED BY: George D
    //*******CREATED DATE: 06/14/2014
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    this.Admin_GetPracticeDetailsBasedOnUserName = function (Admin_UserName, isFromLockOut) {

        var postData = {
            UserName: Admin_UserName,
            practicemodel: EMRPracticeModel
        };

        if (hasValue(isFromLockOut) && isFromLockOut == true) {
            var tempPracticeModel = {
                PracticeID: EMRPracticeModel.SourcePracticeID,
                //LoggedUserID: EMRPracticeModel.SourceLoggedUserID,
                //PracticeName: EMRPracticeModel.SourcePracticeName,
                //DBServerName: EMRPracticeModel.SourceDBServerName,


            };

            postData.practicemodel = tempPracticeModel;
        }

        return CommonService.PostData('POST', EMRCommonService + "GetPracticeInformationBasedOnUserName", postData).then(
            function (result) {
                return result;
            });
    };
    //###################GET PRACTICE DETAILS BASED ON LOGIN USERNAME END#########################


    //###################GET PRACTICE DETAILS BASED ON PRACTICE ID BLOCK START#########################

    //*******PURPOSE: This method is used to get the practice details of user based on practiceid
    //*******CREATED BY: George D
    //*******CREATED DATE: 01/22/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    this.adminGetPracticeInformationBasedOnPracticeID = function () {

        var postData = {
            practicemodel: EMRPracticeModel
        };
        var apiUrl = `${CommonPostService.EHR_Login_API_v1()}GetPracticeInformationByPracticeIdV2`;
        
        if (EMRPracticeModel.isEmergencyWeb) {
            apiUrl = `${CommonPostService.EHR_Login_API_v1()}GetPracticeInfoForEmergencyLogin`;
        }

        if(EMRPracticeModel.isFromNewClientRegWindow){
            apiUrl = CommonPostService.EHR_Practices_Information_API() + "GetPracticeInformationByPracticeIdfromPortalLogin";
        }

        return CommonService.PostData('POST', apiUrl, postData).then(
            function (result) {
                return result;
            });
    };
    //###################GET PRACTICE DETAILS BASED ON PRACTICE ID BLOCK END#########################



    //###################GET FACILITIES FOR CURRENT PRACTICE START#########################

    //*******PURPOSE: This method is used to get all the facility details available with the current practice from the database
    //*******CREATED BY: George D
    //*******CREATED DATE: 06/16/2014
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    this.Admin_GetFacilities = function () {

        var postData = {
            practicemodel: EMRPracticeModel
        };

        return CommonService.PostData('POST', CommonService.EHR_Facilities_API() + "GetLoginInFacilitiesList", postData).then(
            function (result) {
                return result;
            });
    };
    //###################GET FACILITIES FOR CURRENT PRACTICE END#########################



    //###################GET DEFAULT BASED ON USERNAME START#########################

    //*******PURPOSE: This method is used to get the default facility of user based on the username
    //*******CREATED BY: George D
    //*******CREATED DATE: 06/16/2014
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    this.Admin_GetDefaultFacilityBasedOnUserName = function (Admin_UserName) {
        var postData = {
            UserName: Admin_UserName,
            practicemodel: EMRPracticeModel
        };

        return CommonService.PostData('POST', EMRCommonService + "GetDefaultFacilityForUser", postData).then(
            function (result) {
                return result;
            });
    };
    //###################GET DEFAULT BASED ON USERNAME END#########################



    //###################VALIDATING USER CREDENTIALS START#########################

    //*******PURPOSE: This method is used to validate credentials given by the user with EMR user credetials.
    //*******CREATED BY: George D
    //*******CREATED DATE: 06/16/2014
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.Admin_ValidateUserLogin = function (Admin_UserName, Admin_Password, isfromLoginPIN, tempEMRPracticeModel) {
        var postData = {
            UserName: Admin_UserName,
            UserPassword: Admin_Password,
            practicemodel: EMRPracticeModel
        };

        //if called from login through pin
        if (hasValue(isfromLoginPIN) && isfromLoginPIN == true) {
            postData.EHRLoginIsFromLoginPIN = true;
        }

        if (hasValue(tempEMRPracticeModel)) {
            postData.practicemodel = tempEMRPracticeModel;
        }
        postData.isPracticeModelRequired = true;
        //return CommonService.PostData('POST', EMRCommonService + "ValidateLogin", postData).then(//commented for login changes

        //the password (or pin) goes as entered over https, hashing/verification is done by the server
        return self.Admin_ValidateUserLoginContinue(postData);
        // return CommonService.PostData('POST', EMRCommonService + "ValidateUserLogin", postData).then(

    };

        this.Admin_ValidateUserLoginContinue = function (postData) {
            postData.practicemodel = postData.practicemodel || EMRPracticeModel;
            postData.practiceModelRequired = true;
            return GoogleCloudFunctionHandlerService.post("EHR_ValidateUserLoginAfterLockout_GFunc", postData)
                .catch(function () {
                    return CommonService.PostData('POST', CommonPostService.EHR_Login_API_net6() + "ValidateUserLoginAfterLockoutV2", postData);
                });
        };

    //###################VALIDATING USER CREDENTIALS END#########################


    //###################VALIDATING USER AUTHENTICATION BLOCK START#########################

    /**
     * @description builds the payload for the portal google cloud function calls. GoogleCloudFunctionHandlerService assigns
     * PracticeID and LoggedUserID only from the practicemodel of the payload, so the practice model is passed here. Copies are
     * used because the handler strips DBServerName/practicemodel from the payload it sends, and the original postData
     * (with DBServerName) is still needed for the legacy fallback call.
     * @param {*} postData
     * @returns
     */
    function buildPortalGCloudPostData(postData) {
        return angular.extend({}, postData, { practicemodel: angular.extend({}, EMRPracticeModel) });
    }

    /**
     * @description exchanges the single-use random string (rs) issued by the login site's portal handoff
     * for the portal session: tokens plus the stored MetaInfo. This is the only way the portal obtains
     * its first tokens.
     * @param {*} postData { RandomString }
     * @returns
     */
    this.exchangePortalHandoffRandomString = function (postData) {
        return GoogleCloudFunctionHandlerService.post("GetPortalJwtRefreshTokenandMetaInfoBasedOnRandomStrGFunc", buildPortalGCloudPostData(postData), false)
            .catch(function () {
                return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_PortalLogin_API_net6_GlobalWebServerURL() + "GetPortalJwtRefreshTokenandMetaInfoBasedOnRandomString", postData, 3 * 60 * 1000);
            });
    };

    /**
     * @description Path 13 (linked user / contact switch, portal to portal). The switch starts in the
     * portal, which already holds a valid JWT for the current user - that JWT identifies the caller.
     * The body's TargetUserID/TargetUserType identify the person being switched to. The backend validates
     * the caller's JWT and checks the caller is allowed to access the target person in this practice
     * before it issues a random string against that target, same single-use handoff as every other path.
     * @param {*} postData { JwtToken, UserID, UserType, TargetUserID, TargetUserType, APIGateWayPrimaryURL, APIGateWaySecondaryURL, MetaInfo }
     * @returns RandomString
     */
    this.generatePortalSwitchUserRandomString = function (postData) {
        return GoogleCloudFunctionHandlerService.post("GenerateSavePortalSwitchUserRandomStringandMetaInfoGFunc", buildPortalGCloudPostData(postData), false)
            .catch(function () {
                return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_PortalLogin_API_net6_GlobalWebServerURL() + "GenerateSavePortalSwitchUserRandomStringandMetaInfo", postData, 3 * 60 * 1000);
            });
    };

    /**
     * @description method to get jwt token based on refresh token
     * @param {*} postData 
     * @returns 
     */
    this.getTokenByRefreshToken = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.UserLoggedInDateTimeUTC = EMRPracticeModel.UserLoggedInDateTimeUTC;
        postData.OffSetinMinutesUTC = EMRPracticeModel.OffSetinMinutesUTC;
        if (newGcloudFunctionChangesEnabled) {
            return GoogleCloudFunctionHandlerService.post("generatejwtaccesstokenbasedonrefreshtokengcloudfunc", postData)
                .catch(function () {
                    return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_Login_API_net6_GlobalWebServerURL() + "GenerateJwtAccessTokenBasedonRefreshTokenV3", postData, 3 * 60 * 1000);
                });
        }
        else {
            return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_Login_API_net6_GlobalWebServerURL() + "GenerateJwtAccessTokenBasedonRefreshTokenV2", postData, 3 * 60 * 1000).then(function (result) {
                return result;
            });
        }
    };

   /**
     * @description method to get jwt token based on refresh token
     * @param {*} postData 
     * @returns 
     */
    this.getPortalTokenByRefreshToken = function (postData) {
        // postData.practicemodel = EMRPracticeModel;
        postData.UserLoggedInDateTimeUTC = EMRPracticeModel.UserLoggedInDateTimeUTC;
        return GoogleCloudFunctionHandlerService.post("GenerateJwtAccessTokenforPortalBasedonRefreshTokenGFunc", buildPortalGCloudPostData(postData))
            .catch(function () {
                return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_PortalLogin_API_net6_GlobalWebServerURL() + "GenerateJwtAccessTokenforPortalBasedonRefreshTokenV3", postData, 3 * 60 * 1000);
            });
    };

    /**
     * @description issues the single-use code (rs) used to reload the home page (program change, manual refresh).
     * Caller identity comes from the JWT, the body only carries what the home page needs to resume.
     * @param {*} postData { JwtToken, PracticeID, LoggedUserID, UserType, MetaInfo }
     * @returns { RandomString }
     */
    this.authorizeUser = function (postData) {
        postData.OffSetinMinutesUTC = EMRPracticeModel.OffSetinMinutesUTC;
        return GoogleCloudFunctionHandlerService.post("GenerateAuthCodeGFunc", buildPortalGCloudPostData(postData), false)
            .catch(function () {
                return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_Login_API_net6_GlobalWebServerURL() + "GenerateAuthCode", postData, 3 * 60 * 1000);
            });
    };

    /**
     * @description issues the single-use code (rs) that is handed to the AI EHR site (opened in a new tab). The AI site redeems it
     * with GetAIAuthDetailsByAuthCodeGFunc, so this web only needs to call the issue endpoint.
     * Caller identity comes from the JWT, the body only carries what the AI site needs to resume.
     * @param {*} postData { JwtToken, PracticeID, LoggedUserID, UserType, MetaInfo }
     * @returns { RandomString }
     */
    this.generateAIAuthCode = function (postData) {
        postData.OffSetinMinutesUTC = EMRPracticeModel.OffSetinMinutesUTC;
        return GoogleCloudFunctionHandlerService.post("GenerateAIAuthCodeGFunc", buildPortalGCloudPostData(postData), false);
    };

    /**
     * @description redeems the code (rs) from the url. Returns the tokens and the values stored by the login site,
     * so nothing except the code has to travel in the url.
     * @param {*} postData { RandomString }
     * @returns { PracticeID, LoggedUserID, UserType, APIGateWayPrimaryURL, APIGateWaySecondaryURL, JWTAccessToken, JWTRefreshToken, RandomID, MetaInfo }
     */
    this.confirmAuthorization = function (postData) {
        return GoogleCloudFunctionHandlerService.post("GetAuthDetailsByAuthCodeGFunc", buildPortalGCloudPostData(postData), false)
            .catch(function () {
                return CommonPostService.httpPostDataForGlobalDBServer('POST', CommonPostService.EHR_Login_API_net6_GlobalWebServerURL() + "GetAuthDetailsByAuthCode", postData, 3 * 60 * 1000);
            });
    };




    //*******PURPOSE: This method is used to validate user authentication
    //*******CREATED BY: George D
    //*******CREATED DATE: 01/22/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminValidateUserAuthentication = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        //EMRCommonService = EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL + "EMR_Web_WCF_Common/EMRCommon/";

        var EMRCommonServiceLoginURL = EHRLoginService;// EMRCommonService;

        var apiUrl = `${CommonPostService.EHR_Practices_Information_API()}ValidateUserAuthenticationAfterLoginV3`;
        adminPracticeData.practicemodel = EMRPracticeModel;

        if (EnableProductionLoginInSonicWall) {
            EMRCommonServiceLoginURL = "https://web.ehryourway.com/" + "EHR_Login_WebAPI/EHRLogin/";//"EMR_Web_WCF_Common/EMRCommon/";
        }

        if (EMRPracticeModel.isEmergencyWeb) {
            apiUrl = `${CommonPostService.EHR_Login_API_v1()}ValidateUserAuthenticationAfterEmergencyLogin_V2`;
        }
        //modified by mahesh p added timer param for 3 mins of waiting at login  init verification
        return CommonService.PostData('POST', apiUrl, adminPracticeData, 3 * 60 * 1000).then(function (result) {
            return result;
        });
    };
    this.adminValidateUserAuthentication_practicedetailsupdate = function (adminPracticeData, wcfUrl) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        //EMRCommonService = EMRPracticeModel.emrurlsmodel.EMRWebWCFPrimaryExternalURL + "EMR_Web_WCF_Common/EMRCommon/";

        var EMRCommonServiceLoginURL = EHRLoginService;// EMRCommonService;

        var apiUrl = `${CommonPostService.EHR_Practices_Information_API()}ValidateUserAuthenticationAfterLoginV3`;
        adminPracticeData.practicemodel = EMRPracticeModel;

        if (EnableProductionLoginInSonicWall) {
            EMRCommonServiceLoginURL = "https://web.ehryourway.com/" + "EHR_Login_WebAPI/EHRLogin/";//"EMR_Web_WCF_Common/EMRCommon/";
        }

        if (EMRPracticeModel.isEmergencyWeb) {
            apiUrl = `${CommonPostService.EHR_Login_API_v1()}ValidateUserAuthenticationAfterEmergencyLogin_V2`;
        }
        //modified by mahesh p added timer param for 3 mins of waiting at login  init verification
        return CommonService.PostData('POST', apiUrl, adminPracticeData, 3 * 60 * 1000, undefined, undefined, wcfUrl);
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################

    //*******PURPOSE: This method is used to validate portal user authentication
    //*******CREATED BY: George D
    //*******CREATED DATE: 01/22/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminValidatePortalUserAuthentication = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;
        adminPracticeData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        var apiUrl = CommonPostService.EHR_Portal_Login_Api_Login() + "ValidatePortalUserAuthenticationAfterLoginV3"; 

        // return CommonService.PostData('POST', EMRCommonService + "ValidatePortalUserAuthentication", adminPracticeData).then(//commented for login changes
        return CommonService.PostData('POST', apiUrl, adminPracticeData).then(

            function (result) {
                return result;
            });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################
    //###################   GET ALL PRACTICES INFORMATION BLOCK START     #########################

    //*******PURPOSE: This method is used to get the user linked practices if super user
    //*******CREATED BY:SIVA PRASAD J
    //*******CREATED DATE:02/01/2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

    this.adminGetAllPractciesInformation = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        return CommonService.PostData('POST', EMRCommonService + "GetAllPracticeInformation", adminPracticeData).then(
            function (result) {
                return result;
            });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //*******PURPOSE: This method is used to validate user authentication
    //*******CREATED BY: George D
    //*******CREATED DATE: 01/22/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminValidatePortalUserAuthenticationLogin = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;
        var apiUrl = EHRPortalLoginService + "ValidatePortalUserLoginAfterLockOutV3"; 
        // return CommonService.PostData('POST', EMRCommonService + "ValidatePortalUserLogin", adminPracticeData).then(function (result) {//commented for login changes
        return CommonService.PostData('POST', apiUrl, adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //*******PURPOSE: This method is used to validate user authentication
    //*******CREATED BY: George Dfva
    //*******CREATED DATE: 01/22/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminGetServerDateTime = function () {
        var adminPracticeData = {

            practicemodel: EMRPracticeModel
        };

        return CommonService.PostData('POST', EMRCommonService + "GetServerDateTime", adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //*******PURPOSE: This method is used to get user information based on entered user name
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 03/30/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminGetUserInformationBasedOnUserNameService = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;
        //return CommonService.PostData('POST', EMRCommonService + "GetUserInformationBasedOnUserName", adminPracticeData).then(function (result) {
        return CommonService.PostData('POST', EHRLoginService + "GetUserInformationBasedOnUserName", adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################



    //*******PURPOSE: This method is used to get user information based on entered user name
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 03/30/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminForgotPasswordGetUserInfoAndSendOTPService = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        //return CommonService.PostData('POST', EMRCommonService + "ForgotPasswordValidateOTPDetails", adminPracticeData).then(function (result) {
        return CommonService.PostData('POST', EHRLoginService + "ForgotPasswordGetUserInfoAndSendOTP", adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //*******PURPOSE: This method is used to get user information based on entered user name
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 03/30/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminForgotPasswordValidateOTPDetailsService = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        //return CommonService.PostData('POST', EMRCommonService + "ForgotPasswordValidateOTPDetails", adminPracticeData).then(function (result) {
        return CommonService.PostData('POST', EHRLoginService + "ForgotPasswordValidateOTPDetails", adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //*******PURPOSE: This method is used to get user information based on entered user name
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 03/30/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.adminValidationAndUpdateforPhysicianPasswordService = function (adminPracticeData) {

        adminPracticeData.practicemodel = EMRPracticeModel;

        return CommonService.PostData('POST', EMRCommonService + "ValidationAndUpdateforPhysicianPassword", adminPracticeData).then(function (result) {
            return result;
        });
    };
    //###################VALIDATING USER AUTHENTICATION BLOCK END#########################


    //###############################  METHOD TO VALIDATE ENETERED PASSWORD IS CORRECT OR NOT BLOCK START ###############################
    /// *******PURPOSE:THIS IS USED TO VALIDATE ENETERED PASSWORD IS CORRECT OR NOT
    ///*******CREATED BY: UDAY KIRAN V
    ///*******CREATED DATE: 04/18/2018
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.adminServiceValidatePassword = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //   postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        //the password goes as entered over https, hashing/verification is done by the server
        return self.adminServiceValidatePasswordContinue(postData);
    };
    //###############################  METHOD TO VALIDATE ENETERED PASSWORD IS CORRECT OR NOT BLOCK END ###############################

    this.adminServiceValidatePasswordContinue = function (postData){
        return CommonService.PostData('POST', CommonService.EHR_Login_API_net6() + "ValidateLoginPassword", postData).then(function (result) { return result; });
    }

    //###############################  METHOD TO VALIDATE ENETERED LOGIN PIN IS CORRECT OR NOT BLOCK START ###############################
    /// *******PURPOSE:THIS IS USED TO VALIDATE ENETERED LOGIN PIN IS CORRECT OR NOT
    ///*******CREATED BY: UDAY KIRAN V
    ///*******CREATED DATE: 04/18/2018
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.adminServiceValidateLoginPINForDevice = function (postData, isFromImpersonateUserLockOut) {

        //  postData.practicemodel = EMRPracticeModel;

        //   postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonPostService.httpPostData('POST', CommonPostService.EHRGoogleDataStoreUserPIN() + "GetUserInfoBasedOnPin", postData).then(function (result) { return result; });
    };
    //###############################  METHOD TO VALIDATE ENETERED LOGIN PIN IS CORRECT OR NOT BLOCK END ###############################


    //###############################  METHOD TO SAVE IMPERSONATE AUDIT INFORMATION DETAILS START ###############################
    /// *******PURPOSE:THIS IS USED TO SAVE IMPERSONATE AUDIT INFORMATION DETAILS    
    ///*******CREATED BY: RAVI CHANDRA TIRUNAGARI
    ///*******CREATED DATE: 05/07/2018
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************

    this.adminServiceSaveImpersonateAuditDetailsInfo = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        postData.requestComingFrom = "LoginService.js >> adminServiceSaveImpersonateAuditDetailsInfo";
        postData = { ...postData, ..._gcloudBaseUrls };
        if (newGcloudFunctionChangesEnabled)
            return CommonPostService.httpPostData('POST', CommonPostService.EHR_Login_API_net6() + "SaveImpersonateAuditDetailsInfoV3", postData).then(function (result) { return result; });
        else
            return CommonPostService.httpPostData('POST', CommonPostService.EHR_Login_API_net6() + "SaveImpersonateAuditDetailsInfoV2", postData).then(function (result) { return result; });
    };
    //###############################   METHOD TO SAVE IMPERSONATE AUDIT INFORMATION DETAILS END ###############################


    //*******PURPOSE: This method is used to validate credentials given by the user with EMR user credetials.
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 06/28/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.AdminValidateUserLoginAfterLockOut = function (postData) {


        return CommonService.PostData('POST', EMRCommonService + "ValidateLoginPasswordAfterLockOut", postData).then(
            function (result) {
                return result;
            });
    };
    //###################VALIDATING USER CREDENTIALS END#########################





    //######################################################### NEW LOGIN INFORMATION START #########################################################################


    //*******PURPOSE: This method is used to validate login information based on settings
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.ValidatePasswordRulesBasedOnSettings = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

        return CommonService.PostData('POST', CommonService.EMRCommonServiceForLogin() + "ValidatePasswordRulesBasedOnSettings", postData).then(
            function (result) {
                return result;
            });
    };

    //*******PURPOSE: This method is used to save user login information and status  in practice db
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.SaveLoginAndStatusInformationForUsers = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

        return CommonService.PostData('POST', CommonService.EMRCommonServiceForLogin() + "SaveLoginAndStatusInformationForUsers", postData).then(
            function (result) {
                return result;
            });
    };

    //*******PURPOSE: This method is used to save update user login information in data store
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.SaveUpdateUserLoginInformation = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EMRGCloudDataStoreLoginCtrl() + "SaveUpdateUserLoginInformation", postData).then(
            function (result) {
                return result;
            });
    };


    //*******PURPOSE: This method is used to update user login information in practice db
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.UpdateLoginInformationForUsers = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EMRCommonServiceForLogin() + "UpdateLoginInformationForUsers", postData).then(
            function (result) {
                return result;
            });
    };


    //*******PURPOSE: This method is used to delete user login information in practice db
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.DeleteLoginInformationForUsersInPractice = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EMRCommonServiceForLogin() + "DeleteLoginInformationForUsers", postData).then(
            function (result) {
                return result;
            });
    };

    //*******PURPOSE: This method is used to delete user login information in google data store
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.DeleteLoginInformationForUsersInGDataStore = function (postData) {

        postData.practicemodel = EMRPracticeModel;


        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

        return CommonService.PostData('POST', CommonService.EHR_User_LoginInformation() + "DeleteLoginInfoinDBandGDataStore", postData).then(
            function (result) {
                return result;
            });
    };



    //*******PURPOSE: This method is used to save or update login information
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.SaveUpdateLoginInfoInPractice = function (postData) {

        postData.practicemodel = EMRPracticeModel;


        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

    //     var deferred = $q.defer();

    //     let encryptedPassword = getSha1PassCodeEncrytion(postData.UserPassword);

    //     $q.when(encryptedPassword).then(function (hashedLoginPassword) {
    //         postData.UserPassword = hashedLoginPassword;
    //         deferred.resolve(self.SaveUpdateLoginInfoInPracticeContinue(postData));
    //     });

    //     return deferred.promise;
    // };
        // if (EMRPracticeModel.UseGDSLoginValidation) {
            return CommonPostService.httpPostData('POST', CommonPostService.EHR_User_LoginInformation() + "SaveorUpdateUserPracticeLoginInfoinDBandGDataStoreV2", postData);
       // }
    //this.SaveUpdateLoginInfoInPracticeContinue = function(postData){
        // return CommonPostService.httpPostData('POST', CommonPostService.EHR_User_LoginInformation() + "SaveorUpdateUserPracticeLoginInfoinDBandGDataStore", postData).then(
        //     function (result) {
        //         return result;
        //     });
    };

    


    //*******PURPOSE: This method is used to delete login information
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.DeleteLoginInfoInPractice = function (postData) {

        postData.practicemodel = EMRPracticeModel;


        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;

        return CommonService.PostData('POST', CommonService.EHR_User_LoginInformation() + "DeleteLoginInfoInPractice", postData).then(
            function (result) {
                return result;
            });
    };


    //*******PURPOSE: This method is used to save update portal user login information in data store
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    // this.SaveUpdatePortalUserLoginInformation = function (postData) {

    //     postData.practicemodel = EMRPracticeModel;

    //     //SPECIFYING THAT IT IS A ACTION WCF CALL
    //     postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
    //     return CommonPostService.httpPostData('POST', CommonPostService.EHRGoogleDataStorePortal() + "SaveUpdatePortalUserLoginInformation", postData).then(
    //         function (result) {
    //             return result;
    //         });
    // };





    //*******PURPOSE: This method is used to update portal user login information in practice
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    // this.UpdatePortalUserLoginInformationInPractice = function (postData) {

    //     postData.practicemodel = EMRPracticeModel;

    //     //SPECIFYING THAT IT IS A ACTION WCF CALL
    //     postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
    //     return CommonService.PostData('POST', CommonService.EHR_Portal_Login_Api() + "ResetPortalUserNamePasswordDetails", postData).then(
    //         function (result) {
    //             return result;
    //         });
    // };




    //*******PURPOSE: This method is used to get portal identity olumn based on user details
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.getPortalIdentityColumnBasedOnUserName = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EMRCommonService() + "GetPortalIdentityBasedonUserName", postData).then(
            function (result) {
                return result;
            });
    };



    //################# VALIDATE PORTAL USER NAME IN DATASTORE BLOCK START #################
    //********	This is to validate potal user name in datastore and get details
    //********	CREATED BY			: UDAY KIRAN V
    //********	CREATED DATE		: 28 Mar, 2019
    //********	MODIFIED DEVELOPER	: DATE - NAME - WHAT IS MODIFIED
    this.GetUserIdentityandUserTypeBasedonUserName = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', `${CommonPostService.EHR_PortalLogins_GoogleDataStore_API()}GetPortalUserDetailsBasedonUserName`, postData);
        // return CommonService.PostData('POST', CommonService.EMRGCloudDataStoreLogin() + "GetUserIdentityandUserTypeBasedonUserName", postData).then(function (result) {
        //     return result;
        // });
    };
    //################# TO DELETE PORTAL LOGIN INFORMATION BLOCK END #################


    //*******PURPOSE: This method is used to validate potal login information
    //*******CREATED BY: UDAY KIRAN V
    //*******CREATED DATE: 09/08/2018
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.validatePortalUserNameAndPassword = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.GlobalDBServerName = EMRPracticeModel.GlobalDBServerName;
        // postData.GlobalDBServerIp = EMRPracticeModel.GlobalDBServerIp;
        // [SEC-GLOBALDBSERVERIP] disabled - backend no longer uses GlobalDBServerIp; remove after testing
        // postData.GlobalDBServerIp = GlobalDBServerIp;
        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_PortalLogins_GoogleDataStore_API()}GetPortalUserDetailsBasedonUserNameandPasswordV2`, postData);
        // return CommonService.PostData('POST', EMRCommonService + "ValidatePortalUserAndGetDetails", postData).then(
        //     function (result) {
        //         return result;
        //     });
    };

    //######################################################### NEW LOGIN INFORMATION END #########################################################################


    //######################################################### LOGIN LOGOUT REPORT START #########################################################################


    //*******PURPOSE: This method is used save the Login Logout Report 
    //*******CREATED BY:Jashuva S
    //*******CREATED DATE: 07/4/2019
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.saveLoginLogoutTrackInfoService = function (postData,navInfo) {
        postData.practicemodel = EMRPracticeModel;
        postData.requestComingFrom = "LoginService.js >> saveLoginLogoutTrackInfoService";
    /*     if (!EMRPracticeModel.DBServerName) {
            // //logging out the user if db server is not available 
            // setTimeout(function () {
            //     //navigating to login page
            //     window.location.assign(GetEMRPageURLByIndex(2));
            // }, 2000);

            return $q.when(undefined);
            // const errorMailObj = {
            //     ErrorMessage: "DBServerName not Available - UI",
            //     data: postData,
            //     url: EHRLoginService + "SaveLoginLogoutTrackInfo"
            // }
            // errorLogService.errorLogServiceSendErrorMail(errorMailObj);
            // return $q.when(undefined);
        } */
        //// GlobalDBServerIp and GlobalWebServerURL  values are read from config.js file
        // [SEC-GLOBALDBSERVERIP] disabled - backend no longer uses GlobalDBServerIp; remove after testing
        // postData.GlobalDBServerIp = GlobalDBServerIp;
        //SPECIFYING THAT IT IS A ACTION WCF CALL
        //  postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        //old route = EHR_Login_WebAPI/EHRLogin/SaveLoginLogoutTrackInfo
        //re routed new Route =  EHR_Login_API_v1/EHRLogin/SaveLoginLogoutTrackInfo
       // var saveLoginLogoutReportUrl = `${GlobalWebServerURL}EHR_Login_API_v1/EHRLogin/SaveLoginLogoutTrackInfo`;
        // if (EhrLoginLogoutUrlEnabledPractices && EhrLoginLogoutUrlEnabledPractices.has(EMRPracticeModel.PracticeID))
        // if (EhrLoginLogoutAzureSaveUrl)
        // saveLoginLogoutReportUrl = EhrLoginLogoutAzureSaveUrl;
        //navInfo is optional (SecAdminHomeController does not pass it)
        navInfo = navInfo || {};
        if (navInfo.userName && EMRPracticeModel) {
            EMRPracticeModel.LoggedUserName = navInfo.userName;
        }
        if (!EMRPracticeModel || !EMRPracticeModel.LoggedUserName) {
            CommonErrorMailService.Send_ErrorMail_With_ScreenShot("isFromLoginLogoutReport", `Save Login Logout Report  ${_.get(EMRPracticeModel, 'PracticeName')} - ${_.get(EMRPracticeModel, 'LoggedUserName')}`, "", navInfo.navigationFrom);
        }
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Login_API_v1() + "SaveLoginLogoutTrackInfo", postData);
    };
    this.savePortalLoginLogoutTrackInfo = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.requestComingFrom = "LoginService.js >> savePortalLoginLogoutTrackInfo";
        if (!EMRPracticeModel
            || !EMRPracticeModel.LoggedUserID
            || !EMRPracticeModel.PracticeID
            || !EMRPracticeModel.ApplicationType
            || !EMRPracticeModel.clientIP
            || !EMRPracticeModel.PortalUserName
        )
            return;
        postData.clientIP = EMRPracticeModel.clientIP;
        postData.ApplicationType = EMRPracticeModel.ApplicationType;
        postData.PortalUserName = EMRPracticeModel.PortalUserName;
        postData.PracticeName = EMRPracticeModel.PracticeName;
        //EMRPracticeModel.emrurlsmodel.GlobalWebServerURL
         var savePortalLoginLogoutReportUrl = `${GlobalWebServerURL}EHR_PortalLogins_GoogleDataStore_API/PortalGStoreController/SavePortalLoginLogoutTrackInfo`;
        // if (PortalLoginLogoutUrlEnabledPractices && PortalLoginLogoutUrlEnabledPractices.has(EMRPracticeModel.PracticeID))
        if (PortalLoginLogoutAzureSaveUrl)
        savePortalLoginLogoutReportUrl = PortalLoginLogoutAzureSaveUrl;
        return CommonPostService.httpPostData('POST', savePortalLoginLogoutReportUrl, postData);
        // return CommonPostService.httpPostData('POST', `${GlobalWebServerURL}EHR_PortalLogins_GoogleDataStore_API/PortalGStoreController/SavePortalLoginLogoutTrackInfo`, postData);
    };

    //*******PURPOSE: This method is used to Get the login logout Information details of each user
    //*******CREATED BY: Jashuva S
    //*******CREATED DATE: 07/03/2019
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.getLoginLogoutListInfoService = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        // postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        return CommonService.PostData('POST', EMRCommonService + "GetLoginLogoutListInfo", postData).then(
            function (result) {
                return result;
            });
    };


    //*******PURPOSE: This method is used to Get the Total Count of login logout  Information details of each user
    //*******CREATED BY:Jashuva S
    //*******CREATED DATE: 07/03/2019
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.getLoginLogoutTotalCountListInfoService = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        return CommonService.PostData('POST', EMRCommonService + "GetLoginLogoutListTotalCountInfo", postData).then(
            function (result) {
                return result;
            });
    };

    //*******PURPOSE: THIS IS TO GET LOGIN LOGOUT REPORT LIST TO EXPORT TO EXCEL STARTS///
    //*******CREATED BY: SATYA.D
    //*******CREATED DATE: 06/10/2020
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.LoginServiceLoginLogoutListInfoExportToExcel = function (postData) {
        postData.practicemodel = EMRPracticeModel;

        //SPECIFYING THAT IT IS A ACTION WCF CALL
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonService.PostData('POST', EMRCommonService + "LoginLogoutListInfoExportToExcel", postData).then(
            function (result) {
                return result;
            });

    };
    //*******PURPOSE: THIS IS TO GET LOGIN LOGOUT REPORT LIST TO EXPORT TO EXCEL ENDS///

    //######################################################### LOGIN LOGOUT REPORT END #########################################################################
    this.updatePracticeOffSetMinutes = function (currentOffSetMinutes) {
        // 810 minutes is added so that we get indian standard time properly incase of local servers
        const localPractices = new Set([999, 36]);
        adminPracticeOffset = localPractices.has(EMRPracticeModel.PracticeID)
            // to compensate day light saving changes in US, updating offset for local environment 19 May, 2025
            ? 750 //810 
            : currentOffSetMinutes
    }
    this.saveEmployeeLoginAuditLogInfo = function (postData) {
        var employeeAuditSaveServerUrl = CommonPostService.EmployeeLoginApiForAuditLogInsert();
        return CommonPostService.httpPostData('POST', 'EmployeeLoginPracticeLoginAuditLogInsert', postData, undefined, undefined, undefined, employeeAuditSaveServerUrl);
        };
   this.unlockConcurrentAccessInfoForLoggedUser = function (postData = {}) {
            postData.EHRSessionID = EMRPracticeModel.EHRSessionID;
            postData.practicemodel = EMRPracticeModel;
            return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_EFConcurrentAccesLocking_API()}ConcurrentUserAccessingUnLockAllBasedOnUserID`, postData);
        };
        this.getMultiplePracticesItsTicketsPermission = function (postData = {}) {
            postData.practicemodel = EMRPracticeModel;
            return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_InternalProviders()}GetMultiplePracticesItsTicketsPermission`, postData);
        };
        this.getMultiplePracticesItsTicketsLinkedPractices = function (postData = {}) {
            postData.practicemodel = EMRPracticeModel;
            return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_Practices_Information_API()}GetMultiplePracticesItsTicketsLinkedPractices`, postData);
        };
        


    }]);